import React, {Fragment} from 'react';
import {bindActionCreators} from "redux";
import {connect} from 'react-redux';

import Title from "../components/Title";
import {config} from "../../config";
import Helmet from "react-helmet";
import createLink from "../../libs/createLink";
import {Link} from "react-router-dom";

import {deleteCurrentUser, fetchCurrentUser} from "../../creators/currentUser";
import {Button} from "../components/Button";
import history from "../../libs/history";
import {cancelRequestSuppressionUser} from "../../creators/user.requestSuppression";
import {logoutUser} from "../../reducers2/login";


class ConfirmSuppressionAccount extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading : false,
            showMessageConfirmed : false
        }
    }

    componentDidUpdate(prevProps) {
        if(prevProps.currentUserLoading !== this.props.currentUserLoading && !this.props.currentUserLoading){
            if(!this.props.currentUserError.error && this.state.isLoading){
                //this.props.logoutUser();
                this.setState({showMessageConfirmed : true});
                setTimeout(() =>this.props.logoutUser(), 5000);
            }
            this.setState({isLoading : true});
        }
    }

    handleDeleteAccount(){
        this.props.deleteCurrentUser();
    }

    handleCancelDelete(){
        this.props.cancelRequestSuppressionUser(this.props.currentUser._id)
        history.push(createLink("userMeSettingsEmailAndPassword"));
    }

    render() {

        return (
            <div id="confirm-email">
                <Helmet>
                    <title>{config.preTitle}Supression de votre compte{config.postTitle}</title>
                </Helmet>
                <div className="container">
                    <div className="card">
                        {this.props.currentUserInitialized ? (
                            <div className="main-wrapper">
                                <Title heading={"heading-2"} display={"display-2"}>Confirmation de la supression de votre compte</Title>
                                {!this.state.showMessageConfirmed && this.props.currentUser.deleteAccountDate === null ? (
                                    <div className="text">
                                        <p className={"color-danger"}>Il y a aucune demande de supression pour ce compte. </p>
                                    </div>
                                ) : null}
                                {!this.state.showMessageConfirmed && this.props.currentUser.deleteAccountDate !== null && !this.props.currentUser.deleteAccount.isCurrentDemand ? (
                                    <div className="text">
                                        <p className={"color-danger"}>Votre demande a expiré</p>
                                    </div>
                                ) : null}
                                {!this.state.showMessageConfirmed && this.props.currentUser.deleteAccount.isCurrentDemand && !this.props.currentUser.deleteAccount.isConfirmDemand ? (
                                    <div className="text">
                                        <p className={"color-danger"}>Nous vous laissons un temps de réflexion de 24 heures pour changer d'avis.</p>
                                    </div>
                                    ) : null}
                                {!this.state.showMessageConfirmed && this.props.currentUser.deleteAccount.isCurrentDemand && this.props.currentUser.deleteAccount.isConfirmDemand ? (
                                    <Fragment>
                                        <div className="text">
                                            <p className={"color-danger"}>Cette action est définitive, ne le faites pas sur un coup de tête. </p>
                                        </div>
                                        <div className="mt-8 settings-btn-group flex-jc-sb">
                                            <Button size={"medium"}
                                                    className={"mr-8"}
                                                    onClick={()=>{this.handleDeleteAccount()}}
                                                    loading={this.props.currentUserLoading}
                                                    btnStyle={"cancel-reverse"}
                                                    content={"Supprimer mon compte"}/>

                                            <Button size={"medium"}
                                                    onClick={() => this.handleCancelDelete()}
                                                    btnStyle={"primary-reverse"}
                                                    content={"Annuler la demande"}/>

                                        </div>
                                    </Fragment>
                                ) : null}
                                {this.props.currentUserError && this.props.currentUserError.statusCode === 400 &&(
                                    <div className="text"> <p className={"color-danger"}>Nous avons rencontré un problème durant la demande merci de prendre contact avec notre équipe</p></div>
                                )}
                                {this.state.showMessageConfirmed ? (
                                    <div className="text"> <p className={"color-danger"}>Nous allons supprimer votre compte dans les 24h</p></div>
                                ) : null}
                                <div className="text">
                                    <p>Si vous avez le moindre problème n’hésitez pas à nous <Link to={createLink("contact")}>contacter</Link></p>
                                </div>
                            </div>
                        ) : null}

                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    currentUser: state.currentUser.data,
    currentUserLoading: state.currentUser.loading,
    currentUserError: state.currentUser.error,
    currentUserInitialized: state.currentUser.initialized,
});


const mapDispatchToProps = (dispatch) => bindActionCreators({
    cancelRequestSuppressionUser,
    deleteCurrentUser,
    fetchCurrentUser,
    logoutUser
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmSuppressionAccount);

